export const API_URL = 'https://example-data.draftbit.com/books?_limit=50';
export const BOOK_DETAILS_URL = "https://example-data.draftbit.com/books/";

//https://api.nytimes.com/svc/books/v3/lists/current/hardcover-fiction.json?api-key=p7mThQyKlwZcXqLGfSgFObbAurpiJGGg